import {
  CreditCardTypeEnum,
  PaymentMethodStatusEnum,
  PaymentMethodTypeEnum,
} from '@monetize/types/app';

export const PaymentMethodStatusEnumDisplay: {
  [key in PaymentMethodStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CANCELED: 'Canceled',
  EXPIRED: 'Expired',
};

export const PaymentMethodTypeEnumDisplay: {
  [key in PaymentMethodTypeEnum]: string;
} = {
  CREDIT_CARD: 'Credit Card',
  ACH_CREDIT: 'ACH Credit Transfer',
  US_BANK_TRANSFER: 'Bank Transfer (USD)',
  DIRECT_DEBIT: 'ACH Direct Debit',
  MANUAL: 'Manual',
};

// Used for end user display
export const PaymentMethodTypeEnumEndUserDisplay: {
  [key in PaymentMethodTypeEnum]: string;
} = {
  ...PaymentMethodTypeEnumDisplay,
  // These are the only options that actually apply to the end user
  CREDIT_CARD: 'Credit Card',
  DIRECT_DEBIT: 'Bank Account',
};

export const CREDIT_CARD_TYPE_DISPLAY: {
  [key in CreditCardTypeEnum]: string;
} = {
  VISA: 'Visa',
  MASTERCARD: 'Mastercard',
  DISCOVER: 'Discover',
  AMEX: 'American Express',
  DINERS: 'Diners',
  JCB: 'JCB',
  UNIONPAY: 'UnionPay',
};

export const COMPANY_NAME = 'MonetizeNow';

export const NEW_PAYMENT_METHOD = {
  paymentMethodName: '+ New Payment Method',
  value: 'NEW_PAYMENT_METHOD',
};

export const ACH_OR_BANK_TRANSFER = new Set([
  PaymentMethodTypeEnum.ACH_CREDIT,
  PaymentMethodTypeEnum.US_BANK_TRANSFER,
]);

export const REQUIRES_MANUAL_REFUND = new Set([
  PaymentMethodTypeEnum.MANUAL,
  PaymentMethodTypeEnum.ACH_CREDIT,
  PaymentMethodTypeEnum.US_BANK_TRANSFER,
]);

/**
 * Decides whether a refund must go through the manual endpoint. A refund is
 * manual when the user explicitly chose manual mode, OR when the payment type
 * can only be refunded manually — the latter guards against routing a
 * manual-only payment to the electronic endpoint if the UI's paymentMode
 * state has not been set yet.
 */
export const shouldUseManualRefund = (
  paymentMode: 'MANUAL' | 'ELECTRONIC',
  paymentType?: PaymentMethodTypeEnum,
): boolean =>
  paymentMode === PaymentMethodTypeEnum.MANUAL ||
  (!!paymentType && REQUIRES_MANUAL_REFUND.has(paymentType));
